module.exports = __webpack_public_path__ + "img/stock6.2ea3eeba.png";